import { BiCart, BiSolidBadgeDollar } from 'react-icons/bi'

import { Button } from '@/components/Button'
import { SquircleAdapter } from '@/components/SquircleAdapter'
import { useCakeMakerTotal } from '@/store/useCakeMaker'

import './styles.scss'

interface ResumeButtonProps {
  onClick: () => void
}

export function ResumeButton({ onClick }: ResumeButtonProps) {
  const total = useCakeMakerTotal()

  const integerPrice = Math.floor(total)
  const centsPrice = Math.round((total - integerPrice) * 100)

  return (
    <div className="resume-button">
      <SquircleAdapter cornerRadius={12} className="resume-button__container">
        <div className="resume-button__wrapper">
          <p>Total</p>
          <div className="resume-button__wrapper__total">
            <BiSolidBadgeDollar />
            <span className="price">
              {integerPrice}
              <span className="cents">
                {centsPrice.toString().padStart(2, '0')}
              </span>
            </span>
          </div>
        </div>

        <Button
          text="Ver resumo"
          className="resume-button__button"
          rightRender={<BiCart size={24} />}
          onClick={onClick}
          cornerRadius={8}
        />
      </SquircleAdapter>
    </div>
  )
}
